import {
  Card,
  CardContent,
  Grid2,
  Typography,
  Chip,
  Stack,
} from "@mui/material";

const getStatusColor = (status) => {
  switch (status) {
    case "Assigned To Subject":
      return "default";
    case "Returned":
      return "warning";
    case "In Use":
      return "info";
    default:
      return "default";
  }
};

const DrugKitCard = ({ data, prefix }) => {
  return (
    <Grid2 item xs={12} sm={6} md={4} lg={3}>
      <Card
        elevation={3}
        sx={{
          height: "100%",
          borderRadius: 2,
          width: "23vw",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          transition: "0.2s",
          "&:hover": {
            boxShadow: 6,
          },
        }}
      >
        <CardContent>
          {/* Header */}
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            mb={2}
          >
            <Typography fontWeight={600}>
              {prefix} {data.drugKitNumber}
            </Typography>

            <Chip
              label={data.drugStatus}
              size="small"
              color={getStatusColor(data.drugStatus)}
              variant="filled"
            />
          </Stack>

          {/* Body */}
          <Grid2 container direction="column" rowGap={1.2}>
            {/* Pill Count */}
            {data.pillCount > 0 && (
              <Grid2 item>
                <Grid2 container justifyContent="space-between">
                  <Typography variant="body2" color="text.secondary">
                    Pill Count
                  </Typography>

                  <Typography variant="body2" fontWeight={500}>
                    {data.pillCount}
                  </Typography>
                </Grid2>
              </Grid2>
            )}

            {/* Attributes */}
            {data.attributes
              .sort((a, b) => a.displayOrder - b.displayOrder)
              .map((attr, i) => (
                <Grid2 item key={i}>
                  <Grid2 container justifyContent="space-between">
                    <Typography variant="body2" color="text.secondary">
                      {attr.displayName}
                    </Typography>

                    <Typography variant="body2" fontWeight={500}>
                      {attr.attributeValue}
                    </Typography>
                  </Grid2>
                </Grid2>
              ))}
          </Grid2>
        </CardContent>
      </Card>
    </Grid2>
  );
};

export default DrugKitCard;
